import ReactGA from "react-ga4";
import ComicPanel from "../Components/Comics/ComicPanel";
import { Box, Heading, Text } from "@chakra-ui/react";
import GameBannerAd from "../Components/Advertisement/GameBannerAd";

function Comics(){
    ReactGA.send({
    hitType: "pageview",
    page: "/comics",
    title: "Comics",
  });
  return (
    <>

      <Box id='comics' textAlign='center' color='white'>
        <Heading mb='24px' maxW='480px' mx='auto' textAlign='center'>
          See and experience the life of the Leader, Bored!
        </Heading>
        <Text mx='auto' maxW='540px'>
          See and experience the life of the Leader, Bored! See how the four unlikely
          friends interact and live their lives on a day to day basis
        </Text>
        <ComicPanel />
        <GameBannerAd />
      </Box>
    </>
  )
}
export default Comics;